import { AdAccountsByUserQuery } from '../../../apis/graphql/types';
import { RoutePath } from '../../../constants';

type Result = { id: string; isBaymaxEnabled: boolean; orgId: string | null };

export const getSelectedAdAccountData = (
  selectedAdAccountId: string,
  brandsData: AdAccountsByUserQuery['adAccountsByUser']['edges']
): Result | undefined => {
  const adAccountList: Result[] | undefined = brandsData.map(({ node }) => ({
    id: node.id,
    isBaymaxEnabled: !!node.isBaymaxEnabled,
    orgId: node.organizationId,
  }));

  return adAccountList.find(({ id }) => selectedAdAccountId === id);
};

export const getRedirectUrl = (adAccountData: Result | undefined, isBaymaxEnabled: boolean): string => {
  if (adAccountData && (adAccountData.isBaymaxEnabled || isBaymaxEnabled)) {
    return `/${adAccountData.id}`;
  }

  return `/${adAccountData?.id}${RoutePath.CAMPAIGNS}`;
};
